import { render } from "./AwardWinningAgency.vue?vue&type=template&id=0393b569&scoped=true"
import script from "./AwardWinningAgency.vue?vue&type=script&lang=js"
export * from "./AwardWinningAgency.vue?vue&type=script&lang=js"

import "./AwardWinningAgency.vue?vue&type=style&index=0&id=0393b569&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0393b569"]])

export default __exports__